<template>
  <div class="pedido-listado">
    <section class="pedido-steps" v-if="!mostrar_detalle">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route">
                <img :src="require('@/assets/img/backspace.svg')" alt="backspace" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h5 class="pull-left">Listado de las zonas.</h5>
              <router-link :to="route">
                <img class="d-none d-sm-block" :src="require('@/assets/img/backspace.svg')" alt="backspace">
              </router-link>
            </div>
          </div>
        </div>
        <form class="form-filter">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>SKU</label>
                <VueMultiselect
                    v-model="filter.selectedSku"
                    :options="skuOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :loading="loadingSku"
                    placeholder="Select one"
                    label="displayText"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Fecha Inicio</label>
                <Datepicker
                    v-model="filter.start_date"
                    name="start-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Fecha Final</label>
                <Datepicker
                    v-model="filter.final_date"
                    name="final-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Espaciado para dispositivos grandes y medianos -->
            <div class="col-md-8 d-none d-md-block">&nbsp;</div>

            <!-- Botones para dispositivos grandes y medianos -->
            <div class="col-md-4 next-btn d-none d-md-block">
              <a href="javascript:void(0)" @click="getZonas()" class="btn-green">Buscar</a>
              <a @click="cleanFilter" href="javascript:void(0)" class="btn-white">Limpiar</a>
            </div>

            <!-- Botones para dispositivos pequeños -->
            <div style="width: 100%;">
              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a href="javascript:void(0)" @click="getZonas()" class="btn-green"
                   style="margin-right: auto; margin-left: auto;">Buscar</a>
              </div>

              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a @click="cleanFilter" href="javascript:void(0)" class="btn-white"
                   style="margin-right: auto; margin-left: auto;">Limpiar</a>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="confirmado mt-2">
              <!--Para desktop-->
              <table class="bg-white d-none d-sm-table" id="pedidosTable">
                <thead>
                <tr style="background-color: #fffadc;">
                  <th class="text-center">Fecha Inicio
                    <Tooltip :parent="'start_date'" :message="'Fecha de inicio'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Fecha Final
                    <Tooltip :parent="'final_date'" :message="'Fecha de finalización.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Región
                    <Tooltip :parent="'zona_nombre'" :message="'Zona.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">SKU
                    <Tooltip :parent="'sku_name'" :message="'SKU.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Vendedor
                    <Tooltip :parent="'vendedor'" :message="'Vendedor'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Cuota
                    <Tooltip :parent="'cuota'" :message="'Cuota.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Disponible
                    <Tooltip :parent="'disponible_zona'" :message="'Disponible zona.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Editar
                    <Tooltip :parent="'actions'" :message="'Editar la zona.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Elimnar
                    <Tooltip :parent="'actions'" :message="'Elimnar la zona.'">(?)</Tooltip>
                  </th>
                </tr>
                </thead>
                <tbody id="mostrarTablas" v-if="!loading">
                <tr class="b-top zona-row" v-for="(zona, index) in this.items" :key="index">
                  <td class="text-center">{{ zona.Fecha_inicio.substring(0, 10) }}</td>
                  <td class="text-center">{{ zona.Fecha_final.substring(0, 10) }}</td>
                  <td class="text-center">{{ zona.zona_nombre }}</td>
                  <td class="text-center">{{ zona.SKU }}</td>
                  <td class="text-center">{{ zona.vendedor }}</td>
                  <td class="text-center">{{ zona.cuota }}</td>
                  <td class="text-center">{{ zona.disponible_zona }}</td>
                  <td class="text-center">
                    <div class="inline-flex">
                      <img class="mr-2 ml-2 pointer" @click="editar(zona)" href="javascript:void(0)"
                           :src="require('@/assets/img/more.svg')" alt="more">
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="inline-flex">
                      <img class="mr-2 ml-2 pointer" @click="deleteZona(zona.ID)"
                           :src="require('@/assets/img/delete.svg')"
                           alt="more">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <!--Para mobile hay que hacer una tabla por pedido-->
              <table class="bg-white d-block d-sm-none pedidosTableMobile b-top zona-row"
                     v-for="(zona, index) in this.items" :key="index" @click="editar(zona)">
                <tr>
                  <th class="text-center">Fecha Inicio</th>
                  <td class="text-center">{{ zona.Fecha_inicio.substring(0, 10) }}</td>
                </tr>
                <tr>
                  <th class="text-center">Fecha Final</th>
                  <td class="text-center">{{ zona.Fecha_final.substring(0, 10) }}</td>
                </tr>
                <tr>
                  <th class="text-center">Región</th>
                  <td class="text-center">{{ zona.zona_nombre }}</td>
                </tr>
                <tr>
                  <th class="text-center">SKU</th>
                  <td class="text-center">{{ zona.SKU }}</td>
                </tr>
                <tr>
                  <th class="text-center">Vendedor</th>
                  <td class="text-center">{{ zona.vendedor }}</td>
                </tr>
                <tr>
                  <th class="text-center">Cuota</th>
                  <td class="text-center">{{ zona.cuota }}</td>
                </tr>
                <tr>
                  <th class="text-center">Disponible</th>
                  <td class="text-center">{{ zona.disponible_zona }}</td>
                </tr>
              </table>
            </div>
            <div class="p-3" v-if="this.zonas.length === 0 && !this.loading">
              No se encontraron resultados.
            </div>
          </div>
        </div>
        <div class="loading" v-if="loading"></div>
        <div class="row">
          <div class="col-md-12 text-center mb-5">
            <Vue3BsPaginate
                :total="total"
                v-model="currentPage"
                :perPage=perPage
                alignment="center"
            />
          </div>
        </div>
        <div class="row">
          <!-- Botones para dispositivos grandes y medianos -->
          <div class="col-md-12 next-btn d-none d-md-block">
            <input type="button" class="btn-green" value="Nuevo" @click="newZona"/>
            <input type="button" class="btn-green" value="Descargar" @click="exportXlsx"/>
            <input type="button" class="btn-white" value="Importar" @click="openFileUploader"/>
            <input type="button" class="btn-green" value="Reporte" @click="exportReport"/>
          </div>

          <!-- Botones para dispositivos pequeños -->
          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-green" style="margin-right: auto; margin-left: auto;" value="Nuevo"
                   @click="newZona"/>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-green" style="margin-right: auto; margin-left: auto;" value="Descargar"
                   @click="exportXlsx"/>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-white" style="margin-right: auto; margin-left: auto;" value="Importar"
                   @click="openFileUploader"/>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-green" style="margin-right: auto; margin-left: auto;" value="Reporte"
                   @click="exportReport"/>
          </div>
        </div>
        <form novalidate @submit.prevent="onSubmit">
          <file-upload id="fileupload" v-model="form.file" @change="importXlsx" style="display: none;"></file-upload>
        </form>
      </div>
    </section>
    <ZonaEdicion v-if="mostrar_detalle"
                 :selectedZone="this.selectedZone"
                 @ocultarEdicion="ocultarEdicion"
                 @updateSelectedZone="updateSelectedZone"
    ></ZonaEdicion>
    <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
  </div>
</template>

<script>
import {route} from "@/enviroment";
import axios from "axios";
import {Vue3BsPaginate} from 'vue3-bootstrap-paginate';
import Tooltip from "../../snippets/Tooltip.vue";
import FileUpload from "../../snippets/FileUpload.vue";
import ZonaEdicion from "@/components/pages/zonas/ZonaEdicion";

export default {
  name: 'ZonaListado',
  components: {
    Vue3BsPaginate,
    ZonaEdicion,
    Tooltip, FileUpload
  },
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      zonas: [],
      originalZones: [],
      selectedZone: Object,
      mostrar_detalle: false,
      route: route,
      laravelData: {},
      filterData: {
        skus: [],
      },
      selectedSku: null,
      skuOptions: [],
      filter: {},
      form: {
        file: null
      },
      loading: false,
      loadingSku: false,
      deleteZonaModal: false
    }
  },
  // mounted() {
  //   const today = new Date();
  //   this.filter.start_date = new Date(today.getFullYear(), today.getMonth(), 1);
  //   this.filter.final_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  // },
  computed: {
    total() {
      return this.zonas.length
    },
    items() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.zonas.slice(startIndex, endIndex);
    },
  },
  async created() {
    await this.getUser();
    this.getZonas();
    this.getSkus();
  },
  methods: {
    showAlert(type, title, message) {
      this.$refs.alert.showAlert(
          type,
          message,
          title,
          {
            iconSize: 35,
            iconType: 'solid',
            position: 'top right'
          }
      );

      setTimeout(() => {
        this.$refs.alert.$el.style.display = 'none';
      }, 5000);  // 5 segundos y se borra
    },
    editar(zona) {
      this.mostrar_detalle = true;
      this.selectedZone = zona;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    getZonas() {
      this.loading = true;
      let data = this.getFilterData();
      axios.post(`/cuotificador/zones/list`, data)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.laravelData = data.zones;
            this.zonas = data.zones;
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loading = false);
    },
    newZona() {
      location.href = route + 'zona-nueva';
    },
    getUser() {
      const profile = sessionStorage.getItem('mccain_cuotas_user');
      if (profile) {
        const data = JSON.parse(profile);
        this.user = data.firstname + ' ' + data.lastname;
      }
    },
    getSkus() {
      this.loadingSku = true;
      axios.post('cuotificador/data/skus')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.filterData.skus = data.skus;
            this.skuOptions = this.filterData.skus.map((sku) => ({
              value: sku.SKU, // Valor a usar en el v-model
              displayText: `${sku.code} - ${sku.name} - ${sku.material}`, // Texto visible en el VueMultiselect
            }));
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.skus = [];
            this.skuOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loadingSku = false);
    },
    cleanFilter() {
      this.filter = {};
      this.getZonas();
    },
    getFilterData() {
      const filterObject = JSON.parse(JSON.stringify(this.filter));

      if (filterObject.start_date !== undefined && filterObject.start_date !== null && !isNaN(Date.parse(filterObject.start_date))) {
        filterObject.start_date = (new Date(filterObject.start_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(filterObject.start_date))) filterObject.start_date = null;

      if (filterObject.final_date !== undefined && filterObject.final_date !== null && !isNaN(Date.parse(filterObject.final_date))) {
        filterObject.final_date = (new Date(filterObject.final_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(filterObject.final_date))) filterObject.final_date = null;

      if (filterObject.selectedSku !== undefined && filterObject.selectedSku !== null) {
        const sku = this.filter.selectedSku.displayText.split(' - ');
        filterObject.selectedEAN = sku[0];
        filterObject.selectedSku = sku[2];
      }
      return filterObject;
    },
    getFilterQuery() {
      const query = new URLSearchParams(this.getFilterData()).toString();
      return (query) ? `&${query}` : ``;
    },
    exportXlsx() {
      let url = process.env.VUE_APP_BACKEND_API_URL;
      url += `cuotificador/zones/export?${this.getFilterQuery()}`;
      window.open(url, "_self");
    },
    exportReport() {
      let url = process.env.VUE_APP_BACKEND_API_URL;
      url += `cuotificador/zones/report?${this.getFilterQuery()}`;
      window.open(url, "_self");
    },
    importXlsx() {
      if (!this.form.file) return;
      this.loading = true;
      axios.post(`/cuotificador/zones/import`, this.form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      })
          .then((response) => {
            let mime = 'application/vnd.ms-excel';
            let contentType = response.headers["content-type"] || mime;
            let blob = new Blob([response.data], {type: contentType});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            let cd = response.headers["content-disposition"];
            let regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let match = regex.exec(cd);
            link.download = match[1] || "result.xlsx";
            link.click();

            this.form.file = null;
            this.getZonas();
            this.showAlert('success', 'Atención!', `Archivo procesado.`);
          })
          .catch((error) => {
            let msg = '';
            if (error.code === 'ERR_BAD_REQUEST' && error.response?.status === 400) msg = 'Los encabezados son inválidos.';
            else msg = `Ocurrió un error al subir el archivo.`;
            this.form.file = null;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loading = false);
    },

    openFileUploader() {
      document.getElementById('fileupload').click()
    },
    ocultarEdicion(variable) {
      this.mostrar_detalle = variable;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    updateSelectedZone(zona) {
      const index = this.zonas.findIndex((original) => original.id === zona.ID);
      if (index >= 0) this.zonas[index] = zona;
    },
    async deleteZona(id) {
      this.deleteZonaModal = true;
      const confirmed = await this.confirmDelete();
      if (!confirmed) return;
      this.loading = true;
      await axios.delete(`cuotificador/zones/${id}`)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            window.location.reload();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async confirmDelete() {
      return await this.$vbsModal.confirm({
        title: "Eliminar zona",
        message: "¿Está seguro de que desea eliminar esta zona?",
        leftBtnText: 'No',
        rightBtnText: 'Si',
        displayCloseBtn: false
      });
    }
  }
}
</script>

<style>

.zona-row {
  cursor: pointer;
}

.zona-row:hover {
  background-color: #e8e8e8;
}
</style>